import React, { useEffect, useRef } from "react";
import MetaTags from "react-meta-tags";
import gsap from "gsap";

//check active client
const host = window.location.protocol + "//" + window.location.host;
import Config, { ActiveClient } from "../../config";
var LogoSet = (ActiveClient) ? Config[ActiveClient] : Config["cargills"];

var IconImage;
import(`assets/images/logo/${LogoSet.logo}`).then(data => {
    IconImage = host + data.default; 
});

// import IconImage from "assets/images/logo/${Log}"; // Replace with the actual path to your PNG icon

const SplashScreen24x = () => {
    const iconRef = useRef(null);
    const titleRef = useRef(null);
    const subtitleRef = useRef(null);

    const containerStyle = ActiveClient === "mypos" ? {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        background: "linear-gradient(to bottom right, #f0f0f0 0%, #f0f0f0 40%,rgb(194, 42, 93) 97%, #D70E52 100%)", // Gradient for mypos
    } : {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        background: "linear-gradient(to bottom right, #f0f0f0 0%, #f0f0f0 40%, #2E86C1 97%, #0075BF 100%)", // Default gradient
    };

    useEffect(() => {
        const tl = gsap.timeline();

        // Animation for the icon (make it larger)
        tl.fromTo(
            iconRef.current,
            { opacity: 0, scale: 0.5 },
            { opacity: 1, scale: 1, duration: 1, ease: "elastic.out(1, 0.7)" }
        );

        // Animation for the title
        tl.fromTo(
            titleRef.current,
            { opacity: 0, y: -20 },
            { opacity: 1, y: 0, duration: 1, ease: "power3.out" },
            "-=0.5"
        );

        // Animation for the subtitle
        tl.fromTo(
            subtitleRef.current,
            { opacity: 0, y: 20 },
            { opacity: 1, y: 0, duration: 1, ease: "power3.out" },
            "-=0.5"
        );
    }, []);

    return (
        <div>
            <MetaTags>
                <title>Loading...</title>
            </MetaTags>
            <div style={containerStyle}>
                {/* Icon */}
                <img
                    src={IconImage}
                    alt="Your Icon"
                    style={{ ...styles.icon, width: 'auto', height: "100px" }}
                    ref={iconRef}
                />
                {/* Title */}
                <h1 ref={titleRef} style={{ ...styles.title, opacity: 0 }}>
                   {Config[ActiveClient].welcomeMessage}
                </h1>
                {/* Subtitle */}
                <p ref={subtitleRef} style={{ ...styles.subtitle, opacity: 0 }}>
                    Please wait while we log you in...
                </p>
                {/* You can add an image or any other content here */}
            </div>
        </div>
    );
};

const styles = {
    title: {
        fontSize: "28px",
        fontWeight: "bold",
        marginBottom: "10px",
    },
    subtitle: {
        fontSize: "16px",
        color: "#555",
    },
    icon: {
        marginBottom: "16px", // Adjust the margin as needed
    },
};

export default SplashScreen24x;
